import { createFileRoute } from "@tanstack/react-router";
import { LearnLayout } from "#/features/learn/components/learn-layout";

export const Route = createFileRoute("/ko/learn")({
	component: LearnLayout,
});
